import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";

export function ErrorState({ title = "Si è verificato un errore", description = "", onRetry }) {
    return (
        <div
            data-testid="error-state"
            className="flex flex-col items-center justify-center py-16 px-6 text-center bg-white rounded-xl border border-[#DCE3EE]"
        >
            <div className="w-14 h-14 rounded-full bg-[#DC2626]/10 flex items-center justify-center mb-4">
                <AlertTriangle className="w-6 h-6 text-[#DC2626]" />
            </div>
            <h3 className="text-lg font-semibold text-[#172033]">{title}</h3>
            {description && <p className="text-sm text-[#64748B] mt-2 max-w-md">{description}</p>}
            {onRetry && (
                <Button
                    data-testid="error-retry-btn"
                    onClick={onRetry}
                    variant="outline"
                    className="mt-6"
                >
                    Riprova
                </Button>
            )}
        </div>
    );
}

export default ErrorState;
